/**
 * 小程序用户权限管理
 */
<template>
  <div>
    
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>小程序用户权限</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" ref="formInline" class="user-search">
      <el-form-item label="搜索：" prop="name">
        <el-input size="small" v-model="formInline.name" placeholder="输入昵称"></el-input>
      </el-form-item>
      <el-form-item prop="level">
        <el-select size="small" v-model="formInline.level" placeholder="权限等级">
          <el-option v-for="type in authlevels" :label="type.level+'：'+type.desc" :value="type.level" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-refresh-left" @click="resetForm('formInline')">重置</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column sortable prop="id" label="主键" v-if="false" width="200" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="nickname" label="昵称" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <el-tag effect="light" size="medium">{{ scope.row.nickname }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="authlevel" label="权限等级" width="250" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="desc" label="权限说明" width="250" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="createtime" label="创建时间" width="250" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="lastupdate" label="操作时间" width="250" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="主键" v-if="false">
          <el-input  v-model="editForm.id" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="openid" v-if="false">
          <el-input  v-model="editForm.openid" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="用户昵称" prop="nickname">
          <!-- <el-input size="small" v-model="editForm.nickname" auto-complete="off" placeholder="请输入用户昵称"></el-input> -->
          <el-select
            v-model="editForm.nickname"
            filterable
            remote
            :disabled="title == '修改'"
            ref="selectLable"
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            :loading="loading">
            <el-option
              v-for="item in userOptions"
              :key="item.id"
              :label="item.nickname"
              :value="item.openid">
                <span>{{item.nickname}}</span>
              <img :src="item.avatarurl" style="height:32px;float: left;margin-right: 8px;">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="权限等级" prop="authlevel">
          <!-- <el-input size="small" v-model="editForm.authlevel" auto-complete="off" placeholder="请输入权限等级"></el-input> -->
          <el-select v-model="editForm.authlevel" clearable placeholder="请选择">
            <el-option
              v-for="item in authlevels"
              :key="item.id"
              :label="item.level"
              :value="item.level">
                <span>{{item.level}}：{{item.desc}}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间" prop="createtime">
          <el-date-picker v-model="editForm.createtime" type="datetime" disabled auto-complete="off" ></el-date-picker>
        </el-form-item>
        <el-form-item label="操作时间" prop="lastupdate">
          <el-date-picker v-model="editForm.lastupdate" type="datetime" disabled auto-complete="off" ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { WxAuthList,WxSelUser,WxSelAuth,WxSaveUserAuth } from '../../api/basisMG'
import Pagination from '../../components/Pagination'
import {dateFormat} from '../../utils/datetime'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      userOptions:[],
      editForm: {
        id:'',
        openid: '',
        nickname: '',
        authlevel: '',
        createtime:'',
        lastupdate:'',
        token: localStorage.getItem('logintoken')
      },
      authlevels: [],
      // rules表单验证
      rules: {
        nickname: [
          { required: true, message: '用户昵称不能为空', trigger: 'blur' }
        ],
        authlevel: [{ required: true, message: '等级权限不能为空', trigger: 'blur' }]
      },
      formInline: {
        page: 1,
        limit: 10,
        level: [],
        name: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    //初始化权限等级下拉
    WxSelAuth({}).then(res => {
      this.loading = false
      if (res.result != 'success') {
        this.$message({
          type: 'info',
          message: '权限等级请求失败'
        })
      } else {
        this.authlevels = res.list
      }
    })
    .catch(err => {
      this.authlevels = [];
    })
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 数据列表
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      WxAuthList(parameter)
        .then(res => {
          this.loading = false
          if (res.result != 'success') {
            this.$message({
              type: 'info',
              message: '请求失败'
            })
          } else {
            this.listData = res.list
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          this.$message.error(err.response.statusText)
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.openid = row.openid
        this.editForm.nickname = row.nickname
        this.editForm.authlevel = row.authlevel
        this.editForm.createtime = row.createtime
        this.editForm.lastupdate = dateFormat(new Date())
      } else {
        this.title = '添加'
        this.editForm.id = ''
        this.editForm.openid = ''
        this.editForm.nickname = ''
        this.editForm.authlevel = ''
        this.editForm.createtime = dateFormat(new Date())
        this.editForm.lastupdate = dateFormat(new Date())
      }
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.getNickNames({nickname:query})
        }, 200);
      } else {
        this.userOptions = [];
      }
    },
    getNickNames(parameter) {
      WxSelUser(parameter)
        .then(res => {
          console.log(res)
          this.loading = false
          if (res.result != 'success') {
            this.$message({
              type: 'info',
              message: '请求失败'
            })
          } else {
            this.userOptions = res.list
          }
        })
        .catch(err => {
          this.userOptions = [];
        })
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      if(this.title == '添加') {
        this.editForm.openid = this.editForm.nickname
        this.editForm.nickname = this.$refs.selectLable.selected.label;
      }
      this.$refs[editData].validate(valid => {
        if (valid) {
          WxSaveUserAuth(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.result === 'success') {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
      this.resetForm('editForm')
    },
    //重置
    resetForm(formName) {
        this.$refs[formName].resetFields();
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/miniBase/MiniUserRole.vue